var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondenseIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    d: "M182 230L188 234 194 230",
    transform: "matrix(1 0 0 -1 -181 236)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondenseIconMobile);
export default __webpack_public_path__ + "static/media/condense-icon-mobile.de17ce3a7c60cd1f1b27d4c1ee5fdf25.svg";
export { ForwardRef as ReactComponent };